var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"router_view"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path + (_vm.$route.query.user_id || '')}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path + (_vm.$route.query.user_id || '')}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }